module.exports = __webpack_public_path__ + "img/angle-down.b1b999a5.svg";